import { render, staticRenderFns } from "./LoanSummaryMetaData.vue?vue&type=template&id=799d095a&scoped=true&"
import script from "./LoanSummaryMetaData.vue?vue&type=script&lang=ts&"
export * from "./LoanSummaryMetaData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d095a",
  null
  
)

export default component.exports